export function getCookie(name) {
  let matches = document.cookie.match(new RegExp(
    "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
  ));

  if (matches && matches.length > 0) {
    if (matches[1] == 'undefined') {
      return undefined;
    } else {
      return decodeURIComponent(matches[1]);
    }
  } else {
    return undefined;
  }
}

export function setCookie(name, value) {
  var values = {
    'path': '/',
    'max-age': 30 * 86400 // days * seconds_in_a_day
  };

  if (window.Driftrock && Driftrock.settings && Driftrock.settings.domain != undefined) {
    values.domain = Driftrock.settings.domain
  }

  var cookie = name + ' = ' + encodeURIComponent(value);

  for (var optionKey in values) {
    cookie += "; " + encodeURIComponent(optionKey) + "=" + encodeURIComponent(values[optionKey]);
  }

  document.cookie = cookie;
}

export function setStyle(element, attr, value) {
  element.style[attr] = value;
}

export function unsetStyle(element, attr) {
  element.style[attr] = null;
}

export function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

export function wasFormSubmitted(form_id, form_type) {
  return getCookie(`${form_type}-${form_id}-submitted`) == 'true';
}

export function wasFormHidden(form_id, form_type) {
  return getCookie(`${form_type}-${form_id}-hidden`) == 'true';
}

export function markFormAsSubmitted(form_id, form_type) {
  setCookie(`${form_type}-${form_id}-submitted`, 'true');
}

export function markFormAsHidden(form_id, form_type) {
  setCookie(`${form_type}-${form_id}-hidden`, 'true');
}

export function resetFormCookies(form_id, form_type) {
  setCookie(`${form_type}-${form_id}-submitted`, 'false');
  setCookie(`${form_type}-${form_id}-hidden`, 'false');
}

export function reportError(base_url, error, extra_params) {
  var _navigator = {};
  for (var i in navigator) _navigator[i] = navigator[i];

  delete _navigator.plugins;
  delete _navigator.mimeTypes;

  var error_body = Object.assign({
    message: error.message,
    stacktrace: error.stack,
    location: location,
    platform: navigator.platform,
    app_version: navigator.appVersion,
    user_agent: navigator.userAgent,
    navigator: JSON.stringify(_navigator)
  }, extra_params)

  fetch(
      `${base_url}/v2/js_errors`,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: 'post',
        body: JSON.stringify(error_body)
      }
    )
    .then(handleApiError)
    .then(response => response.text())
    .then(data => {})
    .catch(error => {});

}

export function handleApiError(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function locationParams(location_query) {
  if(location_query.substring(1) == "") {
    return {};
  } else {
    const params_map =
      location_query.substring(1)
                    .split("&")
                    .map(str => {
                      let obj = {};
                      let s = str.split("=");
                      obj[s[0]] = s[1];
                      return obj;
                    })
    return Object.assign({}, ...params_map);
  }
}

export function locationParam(location_query, key) {
  return locationParams(location_query)[key]
}

export function loadUrlParamIntoHiddenFields(form_container) {
  const fields = form_container.querySelectorAll('[data-form-field-url-param]');
  const params = locationParams(location.search);
  [...fields].forEach(field => {
    field.setAttribute("value", params[field.name] || "");
  })
}

export function showForm(form) {
  const form_fields_container = form.querySelector('.form-container--fields');
  const form_spinner = form.querySelector('.form-container--loading');
  const form_thank_you = form.querySelector('.form-container--thank-you');

  const widget_title = form.querySelector('.driftrock-widget__title');
  const widget_content = form.querySelector('.driftrock-widget-body__content');

  if(widget_title) {
    widget_title.classList.remove('invisible');
  }

  if(widget_content) {
    widget_content.classList.remove('invisible');
  }

  form_fields_container.classList.remove('invisible');
  form_spinner.classList.add('invisible');
  form_thank_you.classList.add('invisible');
}

export function showLoading(form) {
  const form_fields_container = form.querySelector('.form-container--fields');
  const form_spinner = form.querySelector('.form-container--loading');
  const form_thank_you = form.querySelector('.form-container--thank-you');

  const widget_title = form.querySelector('.driftrock-widget__title');
  const widget_content = form.querySelector('.driftrock-widget-body__content');

  if(widget_title) {
    widget_title.classList.add('invisible');
  }

  if(widget_content) {
    widget_content.classList.add('invisible');
  }

  form_fields_container.classList.add('invisible');
  form_spinner.classList.remove('invisible');
  form_thank_you.classList.add('invisible');
}

export function showThankYou(form) {
  const form_fields_container = form.querySelector('.form-container--fields');
  const form_spinner = form.querySelector('.form-container--loading');
  const form_thank_you = form.querySelector('.form-container--thank-you');

  const widget_title = form.querySelector('.driftrock-widget__title');
  const widget_content = form.querySelector('.driftrock-widget-body__content');

  if(widget_title) {
    widget_title.classList.add('invisible');
  }

  if(widget_content) {
    widget_content.classList.add('invisible');
  }

  form_fields_container.classList.add('invisible');
  form_spinner.classList.add('invisible');
  form_thank_you.classList.remove('invisible');
}

export function showError(form) {
  const form_error = form.querySelector('.form-section--error');

  form_error.classList.remove('invisible');
}

export function hideError() {
  const form_error = document.querySelector('.form-section--error');

  form_error.classList.add('invisible');
}

export function showElement(el) {
  if (el != null) {
    el.classList.remove('invisible');
  }
}

export function hideElement(el) {
  if (el != null) {
    el.classList.add('invisible');
  }
}

export function checkPhoneNumberValidity(countryCode, phoneNumber) {
  return fetch(
    `${base_url()}/v2/forms/validate_phone_number`,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },
      method: 'post',
      body: JSON.stringify({country_code: countryCode, phone_number: phoneNumber})
    }
  )
  .then(handleApiError)
  .then(response => response.json())
  .then(data => data.data);
}

export function validateForm(formContainer) {
  const inputs = formContainer.querySelectorAll("input, select, textarea");

  const formIsValid = Array.from(inputs).every(input => input.checkValidity());

  return formIsValid;
}

export function showValidationErrors(formContainer) {
  const inputs = formContainer.querySelectorAll("input, select, textarea");

  inputs.forEach(input => {
    if (input.checkValidity()) return;

    input.reportValidity();
    input.addEventListener("keydown", (_) => {
      input.setCustomValidity("");
    }, { once: true });
  });
}

function base_url() {
  let dr_obj = window.Driftrock || window.DriftrockWidget;

  if (dr_obj) {
    dr_obj.settings.env

    switch (dr_obj.settings.env) {
      case "development":
        return "http://public-gateway:4010";
      case "staging":
        return "https://external-apis.stagingrock.com";
      default:
        return "https://external-apis.driftrock.com";
    }
  };
}
